import React from "react";
import SensorBase from "./SensorBase";
import { t } from "../../../services/locale.service";
import { TCustomProcessFn } from "../../plotChart/types";
import { TDataItem, TSensorDataResponse } from "../../../services/sensorData.service";

const FIELD = "vpd";
const UNIT = "kPa";

const generateColorForVPD = (item: TDataItem): string => {
  const vpd = item.vpd ?? 0; // Default value if VPD is undefined

  if (vpd < 0.4) {
    return "red"; // Below minimum threshold
  } else if (vpd >= 0.4 && vpd <= 1.6) {
    return "#0c9611"; // Optimal range green
  } else if (vpd > 1.6) {
    return "red"; // Above maximum threshold
  } else {
    return "grey"; // Default fallback
  }
};


const customProcessFn: TCustomProcessFn= (
  graphData: TSensorDataResponse,
  startDate: string,
  endDate: string
) => {
  console.log("Start Date:", startDate, "End Date:", endDate);

  const updatedSample = (graphData.data ?? []).map((item:TDataItem) => ({
    ...item,
    color: generateColorForVPD(item),  
  }));

  return {
    sample: updatedSample,  
    min: graphData.min,  
    max: graphData.max,  
    avg: graphData.avg,  
  };
};

const Vpd: React.FC = () => {
  return (
    <SensorBase field={FIELD} unit={UNIT} about={t("AboutVPD")}
      customProcessFn={customProcessFn}></SensorBase>
  );
};

export default Vpd;